"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataReturnSchema = exports.dataParamsSchema = exports.reauthenticateReturnSchema = exports.reauthenticateParamsSchema = exports.authenticateReturnSchema = exports.authenticateParamsSchema = exports.refreshTokenSchema = exports.refreshTokenPayloadSchema = exports.accessTokenSchema = exports.accessTokenPayloadSchema = void 0;
const APIError_1 = __importDefault(require("../APIError"));
const Const_1 = __importDefault(require("../Const"));
const Socket_1 = require("../Socket");
const jwt_decode_1 = require("jwt-decode");
const socket_io_client_1 = require("socket.io-client");
const zod_1 = __importDefault(require("zod"));
const { ErrorCode } = APIError_1.default;
exports.accessTokenPayloadSchema = zod_1.default.object({ userId: zod_1.default.string() });
exports.accessTokenSchema = exports.accessTokenPayloadSchema.extend({
    exp: zod_1.default.number(),
    iat: zod_1.default.number(),
    sub: zod_1.default.literal(Const_1.default.accessTokenSubject),
});
exports.refreshTokenPayloadSchema = zod_1.default.object({ userSessionId: zod_1.default.string() });
exports.refreshTokenSchema = exports.refreshTokenPayloadSchema.extend({
    exp: zod_1.default.number(),
    iat: zod_1.default.number(),
    sub: zod_1.default.literal(Const_1.default.refreshTokenSubject),
});
exports.authenticateParamsSchema = zod_1.default.object({
    email: zod_1.default.string().optional(),
    googleIdentityToken: zod_1.default.string().optional(),
    phone: zod_1.default.string().optional(),
    token: zod_1.default.string().optional(),
});
exports.authenticateReturnSchema = zod_1.default.object({ accessToken: zod_1.default.string(), refreshToken: zod_1.default.string() });
exports.reauthenticateParamsSchema = zod_1.default.object({ refreshToken: zod_1.default.string().optional() });
exports.reauthenticateReturnSchema = zod_1.default.object({ accessToken: zod_1.default.string(), refreshToken: zod_1.default.string() });
exports.dataParamsSchema = zod_1.default.object({});
exports.dataReturnSchema = zod_1.default.object({ adminUserId: zod_1.default.string().uuid().optional() });
class APIBase {
    get connectedSocket() {
        if (!this.socket)
            throw new Error("Socket is not connected.");
        return this.socket;
    }
    constructor({ baseURL, debug = false, log = console.log, reauthenticate = true, socket = false }) {
        this.accessToken_ = null;
        this.refreshToken_ = null;
        this.reauthLock = false;
        this.socket = null;
        this.autoReauth = reauthenticate;
        this.baseURL = baseURL;
        this.debug = debug;
        this.enableSocket = socket;
        this.log = log;
    }
    get accessToken() {
        return this.accessToken_;
    }
    setAccessToken(accessToken) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            this.accessToken_ = accessToken;
            (_a = this.onAccessTokenChange) === null || _a === void 0 ? void 0 : _a.call(this, accessToken);
            if (this.socket)
                this.socket.disconnect();
            if (accessToken && this.enableSocket) {
                this.socket = new Socket_1.SocketWrapper((0, socket_io_client_1.io)(this.baseURL, { auth: { accessToken } }));
                yield new Promise((resolve) => { var _a; return (_a = this.socket) === null || _a === void 0 ? void 0 : _a.wrappedSocket.once("connect", () => resolve()); });
            }
            else {
                this.socket = null;
            }
        });
    }
    get accessTokenData() {
        if (!this.accessToken)
            return null;
        return exports.accessTokenSchema.parse((0, jwt_decode_1.jwtDecode)(this.accessToken));
    }
    get refreshToken() {
        return this.refreshToken_;
    }
    set refreshToken(token) {
        var _a;
        this.refreshToken_ = token;
        (_a = this.onRefreshTokenChange) === null || _a === void 0 ? void 0 : _a.call(this, token);
    }
    get refreshTokenData() {
        if (!this.refreshToken)
            return null;
        return exports.refreshTokenSchema.parse((0, jwt_decode_1.jwtDecode)(this.refreshToken));
    }
    get localTZOffset() {
        return -Math.round(new Date().getTimezoneOffset() / 60);
    }
    waitForReauthLock() {
        return __awaiter(this, arguments, void 0, function* ({ timeout = 5000 } = {}) {
            const start = Date.now();
            while (this.reauthLock && Date.now() - start < timeout) {
                yield new Promise((r) => setTimeout(r, 100));
            }
        });
    }
    request_(args) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const { method = "GET", path, unauthenticated = false } = args;
            let url = `${this.baseURL}/v1/${path.replace(/^\//, "")}`;
            const headers = Object.assign({ "Content-Type": "application/json" }, ((_a = args.headers) !== null && _a !== void 0 ? _a : {}));
            if (!unauthenticated && this.accessToken)
                headers.Authorization = `Bearer ${this.accessToken}`;
            let init = { method, headers };
            if (method === "GET" && args.data && typeof args.data === "object") {
                const params = new URLSearchParams();
                Object.entries(args.data).forEach(([key, value]) => value !== undefined && params.append(key, String(value)));
                const qs = params.toString();
                if (qs)
                    url += `?${qs}`;
            }
            else if (method !== "GET" && args.data !== undefined) {
                init = Object.assign(Object.assign({}, init), { body: args.data instanceof FormData ? args.data : JSON.stringify(args.data) });
            }
            if (init.body instanceof FormData)
                delete headers["Content-Type"];
            const res = yield fetch(url, init); // Throws only on network, cors, etc. error
            const contentType = res.headers.get("content-type") || "";
            const isJson = contentType.includes("application/json");
            const data = isJson ? yield res.json() : yield res.text();
            if (!res.ok) {
                if (!isJson)
                    throw new Error(`Request failed with status ${res.status}`);
                const _b = data, { message } = _b, info = __rest(_b, ["message"]);
                const error = new APIError_1.default.APIError(res.status, message, info);
                // Clear tokens on banned/invalid-refresh/session-invalid
                if ([ErrorCode.UserBanned, ErrorCode.RefreshTokenInvalid, ErrorCode.SessionInvalid].includes(error.code)) {
                    yield this.setAccessToken(null);
                    this.refreshToken = null;
                }
                // Try reauth on expired/invalid access token
                else if ([ErrorCode.AccessTokenExpired, ErrorCode.AccessTokenInvalid].includes(error.code) &&
                    headers.Authorization &&
                    args.reauthenticate !== false &&
                    this.autoReauth &&
                    this.refreshToken) {
                    yield this.reauthenticate({ refreshToken: this.refreshToken });
                    return this.request_(Object.assign(Object.assign({}, args), { reauthenticate: false }));
                }
                throw error;
            }
            return data;
        });
    }
    request(params) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const start = Date.now();
            const result = yield this.request_(params);
            if (this.debug)
                this.log(`${(_a = params.method) !== null && _a !== void 0 ? _a : "GET"} ${params.path} took ${Date.now() - start}ms`);
            return result;
        });
    }
    authenticate(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const data_ = exports.authenticateParamsSchema.parse(params);
            const data = Object.assign(Object.assign({}, data_), { localTZOffset: this.localTZOffset });
            const response = yield this.request({
                unauthenticated: true,
                data,
                method: "POST",
                path: "/auth",
            });
            yield this.setAccessToken(response.accessToken);
            this.refreshToken = response.refreshToken;
            return exports.authenticateReturnSchema.parse(response);
        });
    }
    deauthenticate() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.refreshTokenData) {
                const { userSessionId } = this.refreshTokenData;
                yield this.request({ method: "DELETE", path: `/session/${userSessionId}` }).catch(() => { });
            }
            yield this.setAccessToken(null);
            this.refreshToken = null;
            return {};
        });
    }
    reauthenticate() {
        return __awaiter(this, arguments, void 0, function* (params = {}) {
            if (this.reauthLock)
                return this.waitForReauthLock();
            this.reauthLock = true;
            try {
                return yield this.reauthenticate_(params);
            }
            finally {
                this.reauthLock = false;
            }
        });
    }
    reauthenticate_() {
        return __awaiter(this, arguments, void 0, function* (params = {}) {
            const data_ = exports.reauthenticateParamsSchema.parse(params);
            const data = Object.assign(Object.assign({ refreshToken: this.refreshToken }, data_), { localTZOffset: this.localTZOffset });
            const response = yield this.request({ data, method: "POST", path: "/reauth", unauthenticated: true });
            yield this.setAccessToken(response.accessToken);
            this.refreshToken = response.refreshToken;
            return exports.reauthenticateReturnSchema.parse(response);
        });
    }
    data() {
        return __awaiter(this, arguments, void 0, function* (params = {}) {
            const data = exports.dataParamsSchema.parse(params);
            const response = yield this.request({ data, method: "GET", path: "/data" });
            return exports.dataReturnSchema.parse(response);
        });
    }
}
exports.default = APIBase;
